import TextBox from 'devextreme-react/text-box';
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import '../../../css/Settings.css';
import { CLASSES } from '../../../shared/Utils';
import GrantPhase from './phases/GrantPhase';
import { getPhasesByGrant } from '../../../../api/v2/PhasesApi';
import { Modules } from '../../../../dtos/Modules';
import { PhaseDto } from '../../../../dtos/PhaseDto';

//TODO fix any
const DCMain = ({ grantData, repopulateData, deepLinkHash }: any) => {
    // Expand/Contract removed (ticket 988): always show all fields.
    const showStaticEntries = true;

    // The fetched PhaseDto for every DC phase, keyed by phase id, so each phase header can show its
    // dates. Every phase renders the tasklist now, whatever its workflow type (ticket 1015). Null
    // until the first load returns.
    const [phaseDtos, setPhaseDtos] = useState<Record<string, PhaseDto> | null>(null);

    // Reloadable: upload-triggered derivation writes dates onto phases other than the one the file
    // landed in (a DD document sets SD's completion), so every header in the module can be stale
    // after an upload - not just the active phase's.
    const loadPhaseDtos = useCallback(async () => {
        if (!grantData?.id) return;
        const res = await getPhasesByGrant(grantData.id, Modules.DC);
        if (!res?.data) return;
        const phases: Record<string, PhaseDto> = {};
        res.data.forEach((p) => { if (p.id) phases[p.id] = p; });
        setPhaseDtos(phases);
    }, [grantData?.id]);

    useEffect(() => { loadPhaseDtos(); }, [loadPhaseDtos]);

    // Every DC task on the grant, ordered by task number then name. The API can return them in any
    // order, so they are sorted here.
    const orderedPhases = useMemo(() =>
        Object.values(phaseDtos ?? {}).sort((a, b) => {
            const numberA = a.defaultPhase?.number ?? 0;
            const numberB = b.defaultPhase?.number ?? 0;
            if (numberA !== numberB) return numberA - numberB;
            return (a.defaultPhase?.name ?? "").localeCompare(b.defaultPhase?.name ?? "");
        }), [phaseDtos]);

    const getViewClasses = (showStaticEntries: boolean, persist: boolean, widthContracted: number, widthExpanded?: number) => {
        if (showStaticEntries) {
            return "dx-field col-" + widthContracted;
        } else if (persist) {
            return "dx-field col-" + widthExpanded;
        } else {
            return "hideFields";
        }
    }

    // The module is enabled but the grant has no DC tasks: the message shows and the task area hides.
    const noPhases = phaseDtos !== null && orderedPhases.length === 0;

    const getSpinnerClass = () => {
        if (noPhases) {
            return CLASSES.DETAILSLOADED;
        } else {
            return CLASSES.DETAILSLOADING;
        }
    }

    const getTitleLoaderClass = () => {
        if (noPhases) {
            return CLASSES.DETAILSLOADING;
        } else {
            return CLASSES.DETAILSLOADEDTIMELINE;
        }
    }

    const getDetailsLoaderClass = () => {
        if (noPhases) {
            return CLASSES.DETAILSLOADING;
        } else {
            return CLASSES.DETAILSLOADED;
        }
    }

    return (
        <>
            <div className={getSpinnerClass()} style={{ marginTop: '200px', marginLeft: '580px', height: '300px' }} >
                <b>Loading Grant Data...</b>
            </div>
            <br />
            <div className="container-fluid panelBody">
                {/* The margins put this row on the same span as the phase header rows below (which
                    sit inside an accordion row and a padded column this row does not have), so each
                    label starts on its field's left edge instead of drifting across the row. */}
                <div className={getTitleLoaderClass()} style={{ marginLeft: 36, marginRight: 10 }}>
                    <TextBox
                        id="noa"
                        value={grantData.noa}
                        visible={false}
                    />

                    <div className="dx-field col-2" style={{ flex: "0 0 21%", maxWidth: "21%" }} />
                    <div className={getViewClasses(showStaticEntries, false, 1)} style={{ flex: "0 0 4.5%", maxWidth: "4.5%" }}>
                        <div className="dx-field-label">NoA +<br />Months</div>
                    </div>
                    <div className={getViewClasses(showStaticEntries, true, 5, 4)}>
                        <div className="row detailsRow">
                            <div className={getViewClasses(showStaticEntries, false, 2)}>
                                <div className="dx-field-label">Projected<br />Start</div>
                            </div>
                            <div className={getViewClasses(showStaticEntries, false, 2)}>
                                <div className="dx-field-label">Projected<br />Completion</div>
                            </div>
                            <div className={getViewClasses(showStaticEntries, true, 3, 4)}>
                                <div className="dx-field-label">Start<br />Date</div>
                            </div>
                            <div className={getViewClasses(showStaticEntries, true, 3, 4)}>
                                <div className="dx-field-label">Completion<br />Date</div>
                            </div>
                            <div className={getViewClasses(showStaticEntries, true, 2, 2)}>
                                <div className="dx-field-label">Last<br />Update</div>
                            </div>
                        </div>
                    </div>
                    <div className={getViewClasses(showStaticEntries, true, 4, 6)} style={{ flex: "1 1 30%", maxWidth: "none" }}>
                        <div className="dx-field-label">
                            <span>Comments</span>
                        </div>
                    </div>
                </div>
                <div className={getDetailsLoaderClass()} style={{ marginTop: "35px" }}>
                    {orderedPhases.map((dto) => (
                        <GrantPhase
                            key={dto.id}
                            currentGrantData={grantData}
                            phaseDto={dto}
                            repopulateData={repopulateData}
                            reloadPhaseDates={loadPhaseDtos}
                            showStaticEntries={showStaticEntries}
                            deepLinkHash={deepLinkHash}
                        ></GrantPhase>
                    ))}
                </div>
            </div>
            <br />
        </>
    );
}

export default DCMain;